import { Vue } from "vue-property-decorator"
import axios from "axios"
import store from "../store/store"

export default class ApiService extends Vue {
    baseHref: string

    constructor(baseHref: string) {
        super()
        this.baseHref = baseHref
    }

    // Generate errorstring from Error
    generateErrorMsg(e: any): string {
        let errormsg: string = ""
        if (e.response.data !== null) {
            errormsg = e.response.data
            store.dispatch("setLoading", false)
        }
        return errormsg
    }

    async getConfigValues() {
        try {
            const response = await axios.get(this.baseHref + "/api/Utils/GetConfigValues")
            return response.data
        } catch (err) {
            throw new Error(this.generateErrorMsg(err))
        }
    }

    async GetConfigValuesForLists() {
        try {
            const response = await axios.get(this.baseHref + "/api/Utils/GetConfigValuesForLists")
            return response.data
        } catch (err) {
            throw new Error(this.generateErrorMsg(err))
        }
    }

    async getLanguageTerms() {
        try {
            const response = await axios.get(this.baseHref + "/api/Utils/GetLanguageTerms")
            return response.data
        } catch (err) {
            throw new Error(this.generateErrorMsg(err))
        }
    }

    async getVAKResults(searchInput: string) {
        try {
            const response = await axios.get(this.baseHref + "/api/VAKHaku/GetVAKResults?searchInput=" + searchInput)
            return response.data
        } catch (err) {
            throw new Error(this.generateErrorMsg(err))
        }
    }

    async getColumnCodeLinks(yknro: string) {
        try {
            const response = await axios.get(this.baseHref + "/api/VAKHaku/GetColumnCodeLinks?yknro=" + yknro)
            return response.data
        } catch (err) {
            throw new Error(this.generateErrorMsg(err))
        }
    }

    async getVAKResultsWithUN(yknro: string) {
        try {
            const response = await axios.get(this.baseHref + "/api/VAKHaku/GetVAKResultsWithUN?yknro=" + yknro)
            return response.data
        } catch (err) {
            throw new Error(this.generateErrorMsg(err))
        }
    }

    async GetLKPKannattavuusLaskuriConfigs() {
        try {
            const response = await axios.get(this.baseHref + "/api/Utils/GetLKPKannattavuusLaskuriConfigs")
            return response.data
        } catch (err) {
            throw new Error(this.generateErrorMsg(err))
        }
    }
}
